var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccountsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 9.625h7.563V11H5.5V9.625zm0 3.438h8.938v1.374H5.5v-1.374z",
    fill: "#707070"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.25 2.75H2.75a1.375 1.375 0 0 0-1.375 1.375v13.75A1.375 1.375 0 0 0 2.75 19.25h16.5a1.375 1.375 0 0 0 1.375-1.375V4.125A1.375 1.375 0 0 0 19.25 2.75zm0 1.375V5.5H2.75V4.125h16.5zm-16.5 13.75v-11h16.5v11H2.75z",
    fill: "#707070"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountsIcon);
export default __webpack_public_path__ + "static/media/accountsIcon.e3a8784cf06768e8713e46c7ed5bb132.svg";
export { ForwardRef as ReactComponent };